<template>
  <svg
    viewBox="1.6 4.065 36.8 31.87"
    width="36.8px"
    height="31.87px"
    fill="none"
    class="logo"
    alt="SCS Logo"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="matrix(1, 0, 0, 1, -0.02900000289082527, -0.02900000289082527)">
      <polygon class="cls-2" points="1.629 35.964 38.429 35.964 38.429 35.954 13.859 29.833 1.629 35.964" style="fill: rgb(0, 125, 186);" />
      <polygon class="cls-3" points="6.259 27.934 1.629 35.964 13.859 29.833 6.259 27.934" style="fill: rgb(178, 210, 53);" />
      <polygon class="cls-4" points="13.859 29.833 38.429 35.954 30.169 21.653 13.859 29.833" style="fill: rgb(0, 189, 242);" />
      <polygon class="cls-5" points="20.029 4.094 7.239 26.243 29.189 19.953 20.029 4.094" style="fill: rgb(237, 29, 36);" />
      <polygon class="cls-2" points="1.629 35.964 38.429 35.964 38.429 35.954 13.859 29.833 1.629 35.964" style="fill: rgb(0, 125, 186);" />
      <polygon class="cls-3" points="6.259 27.934 1.629 35.964 13.859 29.833 6.259 27.934" style="fill: rgb(178, 210, 53);" />
      <polygon class="cls-4" points="13.859 29.833 38.429 35.954 30.169 21.653 13.859 29.833" style="fill: rgb(0, 189, 242);" />
      <polygon class="cls-5" points="20.029 4.094 7.239 26.243 29.189 19.953 20.029 4.094" style="fill: rgb(237, 29, 36);" />
    </g>
  </svg>
</template>
